module.exports = "//static.hsappstatic.net/WebsiteGraderUI/static-1.1473/img/favicon-dark.png"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./img/favicon-dark.png
// module id = 74
// module chunks = 0 1